import { zonedTimeToUtc } from 'date-fns-tz';

export const getDateInUtc = (date: Date) => {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zonedTimeToUtc(date, browserTimezone);
};
